import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FileUpDownLoadDto } from '@shared/src/dtos/base/FileUpDownLoadDto';
import { DocumentDetailDto } from '@shared/src/dtos/document/DocumentDetailDto';
import { PackageDataDetailsDto } from '@shared/src/dtos/shipment/packagedata/PackageDataDetailsDto';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Observable } from 'rxjs-compat';
import { BaseController } from '../../base.controller';
import { SecurityController } from '../../security/security.controller';
import { HDate } from '@shared/src/public-api';
import { TenantCredentialProvider } from '@shared/src/enums/TenantCredentialProvider';

@Injectable({
    providedIn: 'root',
})
export class PackageDataController extends BaseController {

    private getBaseUrl(provider: TenantCredentialProvider){
        if(provider == TenantCredentialProvider.ESchenker)
            return '/eschenker';
        if(provider == TenantCredentialProvider.Dachser)
            return '/dachser';
        return "/";
    }

    constructor(
        @Inject('SecurityController') protected securityController: SecurityController,
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router
    ) {
        super(http, alertService, translateService, loadingService, router);
    }

    public getPackageDetails(packageId: number, provider: TenantCredentialProvider): Observable<PackageDataDetailsDto> {
        return this.get(this.getBaseUrl(provider) + "/details/" + packageId);
    }

    public getPackageDetailsByShipment(shipmentId: number, provider: TenantCredentialProvider): Observable<PackageDataDetailsDto> {
        return this.get(this.getBaseUrl(provider) + "/detailsbyshipment/" + shipmentId);
    }

    public downloadLabel(packageDataId: number, provider: TenantCredentialProvider): Observable<FileUpDownLoadDto> {
        return this.getBusy(this.getBaseUrl(provider) + "/downloadlabel/" + packageDataId);
    }

    public downloadLabelByPackage(packageDataId: number, provider: TenantCredentialProvider): Observable<FileUpDownLoadDto> {
        return this.getBusy(this.getBaseUrl(provider) + "/downloadlabelbypackageid/" + packageDataId);
    }
    
    public downloadLabelByPackages(packageIds: Array<number>, provider: TenantCredentialProvider): Observable<FileUpDownLoadDto> {
        return this.postBusy(this.getBaseUrl(provider) + "/downloadlabels", packageIds, "downloadLabelByPackages");
    }

    public downloadLabelByDate(date: HDate, provider: TenantCredentialProvider): Observable<FileUpDownLoadDto> {
        return this.getBusy(this.getBaseUrl(provider) + "/downloadlabelbydate/" + date.toStringRequest());
    }

    public getDocumentLabel(packageDataId: number, provider: TenantCredentialProvider): Observable<DocumentDetailDto> {
        return this.getBusy(this.getBaseUrl(provider) + "/documentlabel/" + packageDataId);
    }

    public getDocumentLabelByPackage(packageDataId: number, provider: TenantCredentialProvider): Observable<DocumentDetailDto> {
        return this.getBusy(this.getBaseUrl(provider) + "/documentlabelbypackageid/" + packageDataId);
    }

    public createLabel(packageId: number, provider: TenantCredentialProvider): Observable<PackageDataDetailsDto> {
        return this.getBusy(this.getBaseUrl(provider) + "/createlabel/" + packageId);
    }

    public getLabel(packageId: number, provider: TenantCredentialProvider): Observable<PackageDataDetailsDto> {
        return this.getBusy(this.getBaseUrl(provider) + "/getlabel/" + packageId);
    }

    public createLabelByPackages(packageIds: Array<number>, provider: TenantCredentialProvider): Observable<Boolean> {
        return this.postBusy(this.getBaseUrl(provider) + "/createlabel", packageIds, "createLabelByPackages");
    }

    public createLabelByShipment(shipmentId: number, provider: TenantCredentialProvider): Observable<PackageDataDetailsDto> {
        return this.getBusy(this.getBaseUrl(provider) + "/createlabelbyshipmentid/" + shipmentId);
    }

}
